import * as React from "react";
import { FontIcon, FontSizes, FontWeights, IStackItemStyles, IStackTokens, mergeStyles, Stack, Text } from "@fluentui/react";

interface SectionTitleProps {
  title: string;
  isExpanded: boolean;
  toggleIsExpanded: () => void;
}

const containerStackTokens: IStackTokens = { childrenGap: 10 };

const iconClass = mergeStyles({
  color: 'var(--db-fg, #323130)',
  // fontSize: 16
});

const textRegular = mergeStyles({
  color: 'var(--db-fg, #323130)',
  fontSize: FontSizes.size18,
  fontWeight: FontWeights.regular,
});

const SectionTitle: React.FunctionComponent<SectionTitleProps> = ({
  title,
  isExpanded,
  toggleIsExpanded
}: SectionTitleProps) => {
  return (
    <Stack className="xb-subtitle-container" horizontal={true} verticalAlign="center" tokens={containerStackTokens} onClick={toggleIsExpanded}>
      <FontIcon iconName={isExpanded ? "ChevronDown" : "ChevronRight"} className={iconClass} />
      <Text className={textRegular}>{title}</Text>
    </Stack>
  );
};
export default SectionTitle;
